import { render } from "./btcOrders.vue?vue&type=template&id=718d210e"
import script from "./btcOrders.vue?vue&type=script&lang=js"
export * from "./btcOrders.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__